module.exports = __webpack_public_path__ + "static/media/handset.c7ce8e35.svg";